// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AkEz","footer":"styles_footer__2de8k"};